"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultFilterOption = defaultFilterOption;

function defaultFilterOption(option, inputValue) {
  var _option$label;

  return (_option$label = option.label) === null || _option$label === void 0 ? void 0 : _option$label.toLowerCase().includes(inputValue === null || inputValue === void 0 ? void 0 : inputValue.toLowerCase());
}